/**
 * Общие фильтры страницы взаимодействий.
 * Дата: 17.03.2026
 */
import { useEffect, useState } from 'react';
import { addDays, endOfDay, startOfDay } from 'date-fns';
import type { InteractionSectionId } from '@/features/interactions/registry/sectionRegistry';

export interface InteractionDateRange {
  from: Date | null;
  to: Date | null;
}

// 17.03.2026 - Хук хранит общий набор фильтров для shell и секций interactions.
export function useInteractionFilters() {
  const [activeSectionId, setActiveSectionId] = useState<InteractionSectionId>('confirmations');
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [dateRange, setDateRange] = useState<InteractionDateRange>({
    from: startOfDay(new Date()),
    to: endOfDay(addDays(new Date(), 1)),
  });

  useEffect(() => {
    setPage(0);
  }, [activeSectionId, search, dateRange.from?.toISOString(), dateRange.to?.toISOString()]);

  return {
    activeSectionId,
    setActiveSectionId,
    page,
    setPage,
    search,
    setSearch,
    dateRange,
    setDateRange,
  };
}
